const EVENT_PARAM_UPON_CLICK_ON_BUNDLE_BANNER: string = 'is_from_bundle_banner_sku';
const EVENT_PARAM_UPON_CLICK_ON_BUNDLE_ITEM: string = 'is_from_bundle_page_sku';

export const Ga4ViewItemEventParams = {
    clickOnBundleBanner: EVENT_PARAM_UPON_CLICK_ON_BUNDLE_BANNER,
    clickOnBundleItem: EVENT_PARAM_UPON_CLICK_ON_BUNDLE_ITEM,
};
